import { useCallback } from "react";
import { useQuery } from "react-query";
import { http } from "shared/util/http";
import { api } from "constants/RotasAPI";
import { toast } from "react-hot-toast";
import { Cond21CloudResponse } from "types/response/Cond21CloudResponse";

export interface TestStatusPayload {
  status: "CONCLUIDO" | "ERRO" | "PENDENTE" | "PENDENTE_DE_VALIDACAO";
  dataHoraTeste: string | null;
  mensagem?: string | null;
}

interface UseGetStatusTesteEmailProps {
  onSuccess?: (data: Cond21CloudResponse<TestStatusPayload>) => void;
  onError?: (error: any) => void;
}

export const useGetStatusTesteEmail = ({ onSuccess, onError }: UseGetStatusTesteEmailProps = {}) => {
  const defaultOnError = () => {
    toast.error("Erro ao buscar o status do teste de e-mail do Group Pay");
  };

  const { refetch, isFetching } = useQuery<Cond21CloudResponse<TestStatusPayload>>({
    queryKey: ["status-teste-email"],
    queryFn: async () => {
      const response = await http.get<Cond21CloudResponse<TestStatusPayload>>(api.groupPay.getStatusTesteEmail);
      console.log("Resposta do status do teste de e-mail:", response.data);

      return response.data;
    },
    enabled: false,
    retry: false,
  });

  const testar = useCallback(() => {
    return refetch().then((result) => {
      // `refetch` do react-query 3 não rejeita quando a consulta falha: resolve com
      // `isError` e mantém em `data` a resposta da consulta anterior, que fica em cache pela
      // queryKey. Checar só `result.data` repassava esse status antigo como se fosse o atual —
      // e o `onError` de quem usa o hook nunca era chamado.
      if (result.isError) {
        if (onError) {
          onError(result.error);
        } else {
          defaultOnError();
        }
        return;
      }
      if (result.data && onSuccess) {
        onSuccess(result.data);
      }
    }).catch((error) => {
      if (onError) {
        onError(error);
      } else {
        defaultOnError();
      }
    });
  }, [refetch, onSuccess, onError]);

  return { testar, isTesting: isFetching };
};